var isStorageWritable = function (storage) {
    var key = '__test_is_enabled';
    var value = String(Math.random());
    try {
        storage.setItem(key, value);
        var res = storage.getItem(key);
        storage.removeItem(key);
        return res === value;
    }
    catch (_) {
        return false;
    }
};
function isLocalStorageEnabled() {
    return isStorageWritable(window.localStorage);
}
function isSessionStorageEnabled() {
    return isStorageWritable(window.sessionStorage);
}
export var safeJsonParse = function (storedValue) {
    try {
        return JSON.parse(storedValue);
    }
    catch (error) {
        return {};
    }
};
export function storageSaveData(data) {
    var key = data.key, subKey = data.subKey, payload = data.payload, overwrite = data.overwrite, storageType = data.storageType;
    var storage = storageType === 'sessionStorage'
        ? isSessionStorageEnabled() && sessionStorage
        : isLocalStorageEnabled() && localStorage;
    if (storage) {
        if (overwrite) {
            var value = safeJsonParse(storage[key]);
            value[subKey] = payload;
            storage[key] = JSON.stringify(value);
        }
        else if (subKey) {
            var value = storage[key] ? JSON.parse(storage[key]) : {};
            value[subKey] = payload;
            storage[key] = JSON.stringify(value);
        }
    }
}
